import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card-header bg-white d-flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "card-title mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "6",
    y: "17.3137",
    width: "16",
    height: "2",
    rx: "1",
    transform: "rotate(-45 6 17.3137)",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "7.41422",
    y: "6",
    width: "16",
    height: "2",
    rx: "1",
    transform: "rotate(45 7.41422 6)",
    fill: "currentColor"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "border-bottom mb-2 pb-2" }
const _hoisted_7 = { class: "text-primary" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-5" }
const _hoisted_10 = { class: "text-caption text-grey-8" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-weight-medium text-grey-8 text-limit text-right" }, "Singha Beers & wines")
], -1)
const _hoisted_12 = { class: "col-5" }
const _hoisted_13 = { class: "text-caption text-grey-8" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-weight-medium text-grey-8 text-limit text-right" }, "+33 22 00 00 88")
], -1)
const _hoisted_15 = {
  key: 0,
  class: "border-bottom mb-2 pb-2"
}
const _hoisted_16 = { class: "text-primary" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-5" }
const _hoisted_19 = { class: "text-caption text-grey-8" }
const _hoisted_20 = { class: "col-7" }
const _hoisted_21 = { class: "text-weight-medium text-grey-8 text-limit text-right" }
const _hoisted_22 = { class: "col-5" }
const _hoisted_23 = { class: "text-caption text-grey-8" }
const _hoisted_24 = { class: "col-7" }
const _hoisted_25 = { class: "text-weight-medium text-grey-8 text-limit text-right" }
const _hoisted_26 = { class: "col-5" }
const _hoisted_27 = { class: "text-caption text-grey-8" }
const _hoisted_28 = { class: "col-7" }
const _hoisted_29 = { class: "text-weight-medium text-grey-8 text-limit text-right" }
const _hoisted_30 = { class: "col-5" }
const _hoisted_31 = { class: "text-caption text-grey-8" }
const _hoisted_32 = { class: "col-7" }
const _hoisted_33 = { class: "text-weight-medium text-grey-8 text-limit text-right" }
const _hoisted_34 = { class: "col-5" }
const _hoisted_35 = { class: "text-caption text-grey-8" }
const _hoisted_36 = { class: "col-7" }
const _hoisted_37 = { class: "text-weight-medium text-grey-8 text-limit text-right" }
const _hoisted_38 = { class: "col-5" }
const _hoisted_39 = { class: "text-caption text-grey-8" }
const _hoisted_40 = { class: "col-7" }
const _hoisted_41 = { class: "text-weight-medium text-grey-8 text-limit text-right" }
const _hoisted_42 = { class: "border-bottom mb-2 pb-2" }
const _hoisted_43 = { class: "text-primary" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-5" }
const _hoisted_46 = { class: "text-caption text-grey-8" }
const _hoisted_47 = { class: "col-7" }
const _hoisted_48 = { class: "text-weight-medium text-grey-8 text-limit text-right" }
const _hoisted_49 = { class: "col-5" }
const _hoisted_50 = { class: "text-caption text-grey-8" }
const _hoisted_51 = { class: "col-7" }
const _hoisted_52 = { class: "text-weight-medium text-grey-8 text-limit text-right" }
const _hoisted_53 = { class: "col-5" }
const _hoisted_54 = { class: "text-caption text-grey-8" }
const _hoisted_55 = { class: "col-7" }
const _hoisted_56 = { class: "text-weight-medium text-grey-8 text-limit text-right" }
const _hoisted_57 = { class: "col-5" }
const _hoisted_58 = { class: "text-caption text-grey-8" }
const _hoisted_59 = { class: "col-7" }
const _hoisted_60 = { class: "text-weight-medium text-grey-8 text-limit text-right" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-caption text-grey-8" }, "VR :")
], -1)
const _hoisted_62 = { class: "col-7" }
const _hoisted_63 = { class: "text-weight-medium text-grey-8 text-limit text-right" }
const _hoisted_64 = { class: "col-5" }
const _hoisted_65 = { class: "text-caption text-grey-8" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-weight-medium text-grey-8 text-limit text-right" }, "-")
], -1)
const _hoisted_67 = { class: "border-bottom mb-2 pb-2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Service", -1)
const _hoisted_69 = {
  key: 0,
  class: "row"
}
const _hoisted_70 = { class: "col-5" }
const _hoisted_71 = { class: "text-caption text-grey-8" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-weight-medium text-grey-8 text-limit text-right" }, "-")
], -1)
const _hoisted_73 = { class: "col-4" }
const _hoisted_74 = { class: "text-caption text-grey-8" }
const _hoisted_75 = { class: "col-8" }
const _hoisted_76 = { class: "text-weight-medium text-grey-8 text-limit text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "card",
    style: _normalizeStyle(_ctx.isOpen ? 'right:0px' : 'right:-30vw')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("demand.financialSituation.summaryOfTheOffer")) + " LLD_2022", 1)
      ]),
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toogleSummary && _ctx.toogleSummary(...args)))
      }, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("demand.party.roles.CUSTOMER")), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("task.labels.organizationName")) + " :", 1)
          ]),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("middleOffice.party.person.identity.phoneNumber")) + " :", 1)
          ]),
          _hoisted_14
        ])
      ]),
      (_ctx.assets)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assets, (asset, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: asset.id
              }, [
                _createElementVNode("span", _hoisted_16, "Asset " + _toDisplayString(index + 1), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("middleOffice.party.organization.financialSituation.nature")) + " :", 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("demand.asset.vehicle.title")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("demand.asset.category")) + " :", 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(asset.category.label), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("middleOffice.party.organization.financialSituation.label")) + " :", 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(asset.brand.label) + " " + _toDisplayString(asset.model.label), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("demand.asset.vehicle.quantity")) + " :", 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, _toDisplayString(asset.quantity), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("demand.asset.price")) + " HT :", 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.formatNumberWithMask(asset.totalPriceWithDiscount, 2)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("demand.asset.price")) + " TTC :", 1)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.formatNumberWithMask(asset.totalPriceWithTax, 2)), 1)
                  ])
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("demand.tabs.financing")), 1),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t("middleOfficeFinancingForm.label.financingProduct")) + " :", 1)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.product), 1)
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("span", _hoisted_50, "Loyer " + _toDisplayString(_ctx.financingType) + " :", 1)
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.formatNumberWithMask(_ctx.monthlyPayment, 2)), 1)
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t("demand.sliders.duration")) + " :", 1)
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.duration), 1)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("span", _hoisted_58, "1er loyer " + _toDisplayString(_ctx.financingType) + " :", 1)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.formatNumberWithMask(_ctx.firstPayment, 2)), 1)
          ]),
          _hoisted_61,
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.formatNumberWithMask(_ctx.residualValue, 2)), 1)
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t("demand.financialSituation.totalInterestCost")) + ":", 1)
          ]),
          _hoisted_66
        ])
      ]),
      _createElementVNode("div", _hoisted_67, [
        _hoisted_68,
        (!_ctx.services)
          ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.$t("middleOffice.party.organization.financialSituation.label")) + " :", 1)
              ]),
              _hoisted_72
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "row",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("span", _hoisted_74, _toDisplayString(item.type.label) + " :", 1)
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("span", _hoisted_76, _toDisplayString(item.name.label), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ], 4))
}